import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LootBoxScaledCard').create(({ theme }) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    minHeight: '400px',
  },

  modalRoot: {
    backgroundColor: 'rgba(29, 30, 34, 1)',
  },

  boxWrapper: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    justifySelf: 'flex-start',
    width: '100%',
    bottom: '100px',
    paddingBottom: '32px',

    img: {
      position: 'relative',
      maxHeight: '420px',
      top: '100px',
      // backgroundColor: 'red',
    },
  },

  boxImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: '0',
    left: '0',
  },

  arrowAndKeyWrapper: {
    width: '100%',
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    zIndex: 2,
  },

  keyBalaceWrapper: {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    borderRadius: '24px',
    backgroundColor: 'rgba(234, 187, 28, 0.1)',
    backgroundBlendMode: 'darken',
    padding: '0 8px',
  },

  key: {
    width: '14px',
    height: '14px',
  },

  amoutOfKeys: {
    fontFamily: 'Inter',
    fontWeight: 490,
    fontSize: '15px',
    lineHeight: '21px',
    color: theme.colors.text.golden,
    width: '100%',
  },

  boxNameAndSubName: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    zIndex: '3',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: '3',
    gap: '12px',
  },

  plusWrapper: {
    color: 'rgba(255, 255, 255, 0.65)',
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.m,
  },

  description: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.secondary,
    p: {
      margin: '0',
    },
  },

  boxName: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: theme.sizes.texts.fontSize.xl,

    lineHeight: '40px',
    color: theme.colors.text.primary,
  },

  subDescription: {
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.primary,

    '&[data-boxrarity="Rare"]': {
      fontWeight: '450',
      color: theme.colors.borders.rare,
    },
    '&[data-boxrarity="Epic"]': {
      fontWeight: '450',
      color: theme.colors.borders.epic,
    },
    '&[data-boxrarity="Legendary"]': {
      color: theme.colors.borders.legendary,
    },
  },

  limitedText: {
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.error,
  },

  modalTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
  },
  trending: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    p: {
      padding: '0px',
      margin: '0px',
      color: theme.colors.text.secondary,
      span: {
        color: theme.colors.text.primary,
      },
    },
  },
  modalTitleKey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '48px',
    aspectRatio: '1/1',

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  keyList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '12px',
    overflow: 'auto',
    color: theme.colors.text.primary,
  },

  keyListHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: '#757778',
    padding: '12px 0px',
    textTransform: 'uppercase',
  },

  keyListItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
    padding: '12px 0px',
  },
  keyListItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '6px',
    color: theme.colors.text.primary,
  },
  keyListItemKey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '18px',
    aspectRatio: '1/1',

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  textAndArrowWrapper: {
    display: 'flex',
    gap: '8px',
  },

  stars: {
    color: theme.colors.text.secondary,
  },
}))
